import { useEffect } from 'react'

import { useRouter } from 'next/router'

import { NDS_TAGS_MAP, NDS_TAGS_WITH_MY_PAGE_MAP, isIgnorePath } from '@web/libs/nlog/pageview/pageview.constant'
import sendPageViewLog from '@web/libs/nlog/pageview/sendPageViewLog'

const useGlobalPageViewLogging = () => {
  // FIXME: _app.page.tsx 에서 사용되기 때문에 컨텍스트가 initialize 되기전, 초기값을 가져와버리는 문제가 있음.
  // _app.page_tsx에서 선언하는 훅을 제한할 필요가 있을것 같다.
  const router = useRouter()

  useEffect(() => {
    const isTimeline = router.pathname === '/timeline'
    if (isTimeline) return

    if (isIgnorePath(router.pathname, router.query)) return

    if (NDS_TAGS_MAP[router.pathname]) {
      sendPageViewLog(NDS_TAGS_MAP[router.pathname])
      return
    }

    /**
     * 본인뷰, 타인뷰 구분이 필요한 경우에 useIsMyPageViewLogging 를 개별 페이지에서 별도로 호출해서 로깅
     */
    if (NDS_TAGS_WITH_MY_PAGE_MAP[router.pathname]) {
      return
    }

    sendPageViewLog()
  }, [router.pathname, router.query])

  /**
   * @see https://oss.navercorp.com/place/local/pull/18615
   * 타임라인 상세페이지의 카테고리, 기간 필터 변경 시는 PV 전송 X (탭변경만 PV전송)
   */
  useEffect(() => {
    const isTimeline = router.pathname === '/timeline'
    if (!isTimeline) return

    sendPageViewLog()
  }, [router.pathname, router.query.tab])
}

interface Props {
  isMine?: boolean
  pageLoading?: boolean
}

const useIsMyPageViewLogging = ({ isMine, pageLoading }: Props) => {
  const router = useRouter()

  useEffect(() => {
    if (pageLoading) return
    if (isIgnorePath(router.pathname, router.query)) return

    if (NDS_TAGS_WITH_MY_PAGE_MAP[router.pathname]) {
      if (isMine === undefined) return

      const { isMyPage, isOthersPage } = NDS_TAGS_WITH_MY_PAGE_MAP[router.pathname]

      sendPageViewLog(isMine ? isMyPage : isOthersPage)
      return
    }
  }, [router.pathname, router.query, isMine, pageLoading])
}

export { useGlobalPageViewLogging, useIsMyPageViewLogging }
